module.exports = __webpack_public_path__ + "static/improve-vision-ca8e35514ef79c60f623b71b820ab8f3.png";